export default __webpack_public_path__ + "static/media/logo-dark.32a37ec3.svg";